import { useTranslation } from "react-i18next";
import Close from "../../../assets/images/icons/close.svg";
import ParkingIcon from "../../../assets/images/icons/parkingIcon.svg";
import { Images } from "../../Common/Images";

const AlternateParkingSpotModal = ({
    zoneId,
    onClose,
    parkingViolationReportingData,
    isLoading,
    onConfirm,
    selectedDate,
    formatDate,
}) => {
    const { t } = useTranslation();

    if (!parkingViolationReportingData) return null;

    let titleText = `${t("react_parking_violation_reported")}`;
    let topContainerText = "";
    let bottomContainerText = "";
    let btnTxt = "";
    let availableSpotName = "";

    if (parkingViolationReportingData?.Screen === 1) {
        topContainerText = `${t("react_vehicle_parked_wrong_space")}`;
        bottomContainerText = `${t("react_found_alternate_space")} ${parkingViolationReportingData?.Records?.ZoneName}:`;
        availableSpotName = parkingViolationReportingData?.Records?.SpotName;
        btnTxt = `${t("react_yes_take_this_space")}`;
    } else if (parkingViolationReportingData?.Screen === 2) {
        topContainerText = `${t("react_parking_violation_reported")}`;
        bottomContainerText = `${t("no_parking_space_available")}`;
        btnTxt = t("confirm");
    } else if (parkingViolationReportingData?.Screen === 3) {
        if (parkingViolationReportingData?.Records?.SpotId === 0) {
            topContainerText = `${t("react_vehicle_not_registered")}`;
            bottomContainerText = `${t("no_parking_space_available")}`;
            btnTxt = t("confirm");
        } else if (parkingViolationReportingData?.Records?.SpotId > 0) {
            topContainerText = `${t("react_vehicle_not_registered")}`;
            bottomContainerText = `${t("react_found_alternate_space")}`;
            btnTxt = `${t("react_yes_take_this_space")}`;
            availableSpotName = parkingViolationReportingData?.Records?.SpotName;
        }
    }

    return (
        <div id="divAlternateParkingSpotModal">
            <div
                className="modal"
                style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
                id="dateModal"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
            >
                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                    <div className="modal-content modal-radius">
                        <div className="modal-body">
                            <div className="close-modal">
                                <a
                                    onClick={(e) => {
                                        e.preventDefault();
                                        onClose();
                                    }}
                                >
                                    <img src={Close} aria-label="Close" />
                                </a>
                            </div>

                            <div className="pt-4 text-center">
                                <h5 className="popup-title pe-3">{titleText}</h5>
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <img src={Images.Participant} alt="" />
                                    <h4>{parkingViolationReportingData?.Records?.PlateNo}</h4>
                                </div>
                            </div>

                            <div className="pt-4 text-center">
                                <p>{topContainerText}</p>
                            </div>
                            <div className="divider-line mt-3"></div>
                            <div className="text-center my-34">
                                <img src={ParkingIcon} className="img-fluid" alt="Parking Booking" />
                            </div>

                            <div className="modal-details text-center">
                                <p>
                                    {bottomContainerText}
                                    <h5 className="color-green d-block mt-2 mb-0">{availableSpotName || ""}</h5>
                                </p>
                            </div>

                            <button
                                className="main-btn fill-green-btn w-100"
                                onClick={async (e) => {
                                    e.preventDefault();
                                    onClose();
                                    if (!isLoading && parkingViolationReportingData?.Records?.SpotId > 0) {
                                        await onConfirm(zoneId, formatDate(selectedDate));
                                    }
                                }}
                            >
                                {btnTxt}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AlternateParkingSpotModal;
